import { clientApi as api } from '@common/api'
import { useAppDispatch, useAppSelector, useTranslate } from '@common/hooks'
import { uninstallApplication } from '@redux/slices/application/application'
import cx from 'classnames'
import { useRouter } from 'next/router'
import { useState } from 'react'

import classNames from './styles.module.scss'


export default function UninstallButton(): JSX.Element | null {
  const application = useAppSelector(store => store.application.data) as IApplication
  const router = useRouter()
  const previousListPage = useAppSelector(store => store.common.data.previousListPage)
  const { translate } = useTranslate()
  const [initialRender] = useState(application.isInstalled)
  const dispatch = useAppDispatch()

  const uninstallApp = async () => {
    try {
      await api.post<unknown>('/api/apps/uninstall', {
        appId: application.id,
      })
      dispatch(uninstallApplication())
      void router.push(previousListPage || '/apps')
    } catch (error) {}
  }
  const isDisabled = !application.isInstalled

  if(!initialRender) {
    return null
  }

  return (
    <label
      onClick={isDisabled ? undefined : uninstallApp}
      className={cx(classNames.uninstall, isDisabled && classNames.disabled)}
      data-test="uninstall-btn"
    >
      {application.isInstalled && translate('Uninstall')}
      {!application.isInstalled && translate('Uninstalled')}
    </label>
  )
}
// make sure it stays open and goes to the front
